import './UpsellContactSupport.scss';
import React from 'react'
import { getLimitsForTier } from '../../shared/plans';

export default function UpsellContactSupport() {

  return (
    <div className='sales-modal-container'>
      <div className='sales-modal-done upsell-contact-support-done'>
        <h2>
          <i className='fa-regular fa-lightbulb' />&nbsp; Need more than { getLimitsForTier('gold').ranking_lists } ranking lists?
        </h2>
        <p>Get in touch with us at <a target='_blank' href='mailto:support@wordtracker.com'>support@wordtracker.com</a><br/>to talk about a custom plan.</p>
      </div>
    </div>
  )
}
